import { isMobile } from 'react-device-detect';

import { SRPTwoColumnConfig } from '../(search)/[saleType]/[[...searchPath]]/helper/getTwoColumnExperiment';

export const SRP_TWO_COLUMN_COOKIE_KEY = 'srp-two-column';

export const getSRPVariant = (onlyCheckVariant?: boolean): 'Grid' | 'List' => {
    try {
        // Check for view parameter first
        if (typeof window !== 'undefined' && !onlyCheckVariant) {
            const urlParams = new URLSearchParams(window.location.search);
            const viewParam = urlParams.get('view');
            if (viewParam === 'list') {
                return 'List';
            }
        }

        const cookieValue = getCookie(SRP_TWO_COLUMN_COOKIE_KEY);

        if (cookieValue) {
            const parsedData = JSON.parse(
                decodeURIComponent(cookieValue),
            ) as SRPTwoColumnConfig;

            if (onlyCheckVariant)
                return parsedData?.variant === 'B' &&
                    parsedData?.isValidLocation &&
                    !isMobile
                    ? 'Grid'
                    : 'List';

            return parsedData?.variant && parsedData?.isActive && !isMobile
                ? 'Grid'
                : 'List';
        }
    } catch (error) {
        console.error('Error parsing SRP variant cookie:', error);
    }

    return 'List';
};

const getCookie = (name: string): string | null => {
    if (typeof document === 'undefined') return null;

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop()?.split(';').shift() || null;
    }
    return null;
};
